import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import LoyaltySearch from "../../../../../styles/img/loyalty-search-img.png"
import LoyaltyPurchase from "../../../../../styles/img/loyalty-purchase-img.png"
import LoyaltyEarn from "../../../../../styles/img/loyalty-earn-img.png"
import Enjoy from "../../../../../styles/img/enjoy.png"
import Rate from "../../../../../styles/img/rate.png"
import {UiHowSectionWorkCol,UiHowSectionWorkColHeading} from"../../../components/common/UiHowSectionWorkCol"

export default function HowLoyaltyWorks(props) {


    return (
        <>
            <UiSingleRow>
                <UiCol lg="2"><UiHowSectionWorkColHeading title="How Loyalty Works"/></UiCol>
                <UiCol lg="10">
                    <UiSingleRow>
                        <UiHowSectionWorkCol heading="Search" image={LoyaltySearch} content="Visit any of our participating online stores via their link on this site. "/>
                        <UiHowSectionWorkCol heading="Purchase" image={LoyaltyPurchase} content="Check their Loyalty offers and purchase items."/>
                        <UiHowSectionWorkCol heading="Earn" image={LoyaltyEarn} content="Points will automatically be loaded to you account upon checkout."/>
                    </UiSingleRow>
                </UiCol>
            </UiSingleRow>
        </>
    )
}
